import React, { useState } from 'react';
import { AssetField } from './AssetPickerModal';
import { ALLOWED_EMOTIONS, listCharacterEmotionKeys } from './emotion-presets';
import styles from './scenario-studio.module.css';

interface EmotionsEditorProps {
  scenarioId: string;
  emotions: Record<string, string>;
  onChange: (emotions: Record<string, string>) => void;
}

export { listCharacterEmotionKeys } from './emotion-presets';

export const EmotionsEditor: React.FC<EmotionsEditorProps> = ({
  scenarioId,
  emotions,
  onChange,
}) => {
  const [newEmotion, setNewEmotion] = useState<string>('neutre');
  const entries = listCharacterEmotionKeys(emotions);

  const updateEmotionAsset = (key: string, asset: string) => {
    onChange({ ...emotions, [key]: asset });
  };

  const removeEmotion = (key: string) => {
    const next = { ...emotions };
    delete next[key];
    onChange(next);
  };

  const availablePresets = ALLOWED_EMOTIONS.filter((p) => !(p in emotions));

  const addEmotion = () => {
    if (!newEmotion || newEmotion in emotions) return;
    onChange({ ...emotions, [newEmotion]: '' });
  };

  const selectValue = availablePresets.includes(newEmotion as (typeof ALLOWED_EMOTIONS)[number])
    ? newEmotion
    : availablePresets[0] ?? '';

  return (
    <div className={styles.emotionsEditor}>
      <div className={styles.panelHeader}>
        <h4>Émotions (sprites)</h4>
      </div>

      {entries.length === 0 && (
        <p className={styles.hint}>
          Ajoutez au moins l&apos;émotion « neutre » avec un asset pour l&apos;affichage en jeu.
        </p>
      )}

      {entries.map((key) => (
        <div key={key} className={styles.emotionRow}>
          <span className={styles.emotionLabel}>{key}</span>
          <div className={styles.emotionAsset}>
            <AssetField
              scenarioId={scenarioId}
              label=""
              value={emotions[key] ?? ''}
              subdir="characters"
              onChange={(path) => updateEmotionAsset(key, path)}
            />
          </div>
          <button
            type="button"
            className={styles.btnDanger}
            onClick={() => removeEmotion(key)}
            title="Supprimer cette émotion"
          >
            ×
          </button>
        </div>
      ))}

      {availablePresets.length > 0 && (
        <div className={styles.addEmotionRow}>
          <select
            className={styles.select}
            value={selectValue}
            onChange={(e) => setNewEmotion(e.target.value)}
          >
            {availablePresets.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
          <button type="button" className={styles.btnSecondary} onClick={addEmotion}>
            + Émotion
          </button>
        </div>
      )}
    </div>
  );
};
